//! Services
export const dataService = {
	hy: {
		title: 'Ծառայություններ',
		item: [
			{
				id: 1,
				title: 'Տեղեկատվական տեխնոլոգիաներ',
				url: 'technologies',
				image: { src: '/images/technologies.webp', alt: 'technology' },
				content: [
					{
						url: 'software-development',
						title: 'Ծրագրային ապահովում',
						image: { src: '/images/1.webp', alt: 'technology2' },
						description: [{ name: 'Ծրագրային ապահովման մշակում' }, { name: 'Ծրագրային ապահովման նախագծում' }],
					},
				],
			},
			{
				id: 2,
				title: 'Կապ',
				url: 'communication',
				image: { src: '/images/communication.webp', alt: 'technology' },
				content: [
					{
						url: 'network-design',
						title: 'Նախագծում՝ կապի բնագավառում',
						image: { src: '/images/2.webp', alt: 'technology' },
						description: [{ name: 'Անլար համակարգչային ցանցերի նախագծում' }, { name: 'Կորպորատիվ համակարգչային ցանցերի նախագծում' }, { name: 'Համակարգչային ցանցերի նախագծում' }, { name: 'Տեղային համակարգչային ցանցերի նախագծում' }],
					},
					{
						url: 'network-services',
						title: 'Տարաբնույթ ծառայություններ կապի բնագավառում',
						image: { src: '/images/3.webp', alt: 'technology3' },
						description: [{ name: 'Գլոբալ համակարգչային ցանցերի ստեղծում՝ ձեռնարկությունների համար' }],
					},
				],
			},
			{
				id: 3,
				title: 'Պահպանություն և անվտանգություն',
				url: 'maintenance-security',
				image: { src: '/images/security.webp', alt: 'technology3' },
				content: [
					{
						url: 'network-security',
						title: 'Ցանցային անվտանգության համակարգեր',
						image: { src: '/images/4.webp', alt: 'technology3' },
						description: [{ name: 'Ցանցային անվտանգության համակարգեր', tag: ['մոնտաժում', 'տեղակայում', 'տեղադրում'] }],
					},
					{
						url: 'computer-services',
						title: 'Համակարգչային ծառայություններ',
						image: { src: '/images/5.webp', alt: 'technology3' },
						description: [{ name: 'Ծրագրային ապահովման սպասարկում' }, { name: 'Ծրագրային ապահովման սպասարկում՝ ձեռնարկությունների համար' }, { name: 'Համակարգչային ծրագրերի', tag: ['տեղադրում', 'նորացում'] }, { name: 'Տարաբնույթ համակարգչային ծառայություններ' }, { name: 'Օպերացիոն համակարգի', tag: ['սպասարկում', 'տեղադրում', 'նորացում'] }],
					},
					{
						url: 'equipment-maintenance',
						title: 'Սարքավորումների սպասարկում',
						image: { src: '/images/tt2.webp', alt: 'technology' },
						description: [{ name: 'Կորպորատիվ համակարգչային ցանցերի', tag: ['մոնտաժում', 'տեղակայում', 'տեղադրում'] }, { name: 'Սերվերների', tag: ['մոնտաժում', 'տեղակայում', 'տեղադրում'] }, { name: 'Սերվերների նորոգում, վերանորոգում, սպասարկում' }, { name: 'Տեղային համակարգչային ցանցերի', tag: ['մոնտաժում', 'տեղակայում', 'տեղադրում'] }, { name: 'Տեղային համակարգչային ցանցերի սպասարկում' }, { name: 'Տեղային համակարգչային ցանցերի սպասարկում՝ բաժանորդային սկզբունքով' }],
					},
				],
			},
		],
	},

	en: {
		title: 'Services',
		item: [
			{
				id: 1,
				title: 'Information Technologies',
				url: 'technologies',
				image: { src: '/images/technologies.webp', alt: 'technology2' },
				content: [
					{
						url: 'software-development',
						title: 'Software Development',
						image: { src: '/images/1.webp', alt: 'technology2' },
						description: [{ name: 'Software development' }, { name: 'Software design' }],
					},
				],
			},
			{
				id: 2,
				title: 'Communication',
				url: 'communication',
				image: { src: '/images/communication.webp', alt: 'technology' },
				content: [
					{
						image: { src: '/images/2.webp', alt: 'technology' },
						url: 'network-design',
						title: 'Network Design',
						description: [{ name: 'Wireless network design' }, { name: 'Corporate network design' }, { name: 'Computer network design' }, { name: 'Local network design' }],
					},
					{
						image: { src: '/images/3.webp', alt: 'technology' },
						url: 'network-services',
						title: 'Various Communication Services',
						description: [{ name: 'Global network creation for enterprises' }],
					},
				],
			},
			{
				id: 3,
				title: 'Maintenance & Security',
				url: 'maintenance-security',
				image: { src: '/images/security.webp', alt: 'technology3' },
				content: [
					{
						url: 'network-security',
						title: 'Network Security Systems',
						image: { src: '/images/4.webp', alt: 'technology3' },
						description: [{ name: 'Network security systems', tag: ['installation', 'deployment', 'setup'] }],
					},
					{
						url: 'computer-services',
						title: 'Computer Services',
						image: { src: '/images/5.webp', alt: 'technology3' },
						description: [{ name: 'Software maintenance' }, { name: 'Enterprise software maintenance' }, { name: 'Computer programs', tag: ['installation', 'upgrade'] }, { name: 'Various computer services' }, { name: 'Operating system', tag: ['maintenance', 'installation', 'upgrade'] }],
					},
					{
						url: 'equipment-maintenance',
						title: 'Equipment Maintenance',
						image: { src: '/images/tt2.webp', alt: 'technology3' },
						description: [{ name: 'Corporate networks', tag: ['installation', 'deployment', 'setup'] }, { name: 'Servers', tag: ['installation', 'deployment', 'setup'] }, { name: 'Server repair, restoration, maintenance' }, { name: 'Local networks', tag: ['installation', 'deployment', 'setup'] }, { name: 'Local network maintenance' }, { name: 'Subscription-based local network maintenance' }],
					},
				],
			},
		],
	},
};

//! Privacy Policy
export const dataPrivacyPolicy = {
	effectiveDate: '20/02/2025',
	lastUpdated: '25/02/2025',

	hy: {
		titles: [{ title: 'Ներածություն' }, { title: 'Ի՞նչ տեղեկություններ ենք հավաքում' }, { title: 'Ինչպե՞ս ենք օգտագործում ձեր տվյալները' }, { title: 'Տեղեկությունների փոխանցում և բացահայտում' }, { title: 'Տվյալների անվտանգություն' }, { title: 'Տվյալների պահպանում' }, { title: 'Ձեր իրավունքներն ու ընտրանքները' }, { title: 'Երրորդ կողմերի հղումներ' }, { title: 'Գաղտնիության քաղաքականության փոփոխություններ' }, { title: 'Կապ մեզ հետ' }],
		contents: [
			{
				title: 'Ներածություն',
				description: '"NET SPACE" («մենք», «մեր» կամ «մեզ») պարտավորվում է պաշտպանել ձեր գաղտնիությունը։ Այս Գաղտնիության քաղաքականությունը ներկայացնում է, թե ինչպես ենք մենք հավաքում, օգտագործում, հրապարակում և պաշտպանում ձեր տեղեկատվությունը, երբ օգտվում եք մեր ծառայություններից՝ կապված համակարգչի, համակարգչային ցանցերի և սերվերային ծրագրային ապահովման սպասարկման հետ Հայաստանի Հանրապետության տարածքում:',
			},
			{
				title: 'Տեղեկատվություն, որը մենք հավաքում ենք',
				description: 'Մենք կարող ենք հավաքել հետևյալ տեսակի տեղեկատվություն. անձնական տվյալներ (անուն, էլ. փոստի հասցե, հեռախոսահամար և այլ կոնտակտային տվյալներ), տեխնիկական տվյալներ (IP հասցեներ, սարքի տվյալներ և մուտքի տեղեկամատյաններ), սպասարկման հետ կապված տվյալներ (ձեր համակարգչի, ցանցի կամ սերվերի սպասարկման կարիքների մասին մանրամասներ), վճարման տվյալներ (եթե կիրառելի է, մենք հավաքում ենք հաշվարկային տվյալներ գործարքները մշակելու համար):',
			},
			{
				title: 'Ինչպես ենք մենք օգտագործում ձեր տեղեկատվությունը',
				description: 'Մենք օգտագործում ենք հավաքագրված տեղեկատվությունը՝ մեր ծառայությունները մատուցելու, պահպանելու և բարելավելու համար, տեխնիկական խնդիրները հայտնաբերելու և լուծելու համար, վճարումները և հաշիվները մշակելու համար, ձեզ հետ հաղորդակցվելու համար՝ կապված ծառայությունների հարցումների կամ թարմացումների հետ, ինչպես նաև Հայաստանի Հանրապետության օրենսդրական և կարգավորող պահանջներին համապատասխանելու համար:',
			},
			{
				title: 'Տեղեկատվության փոխանակում և բացահայտում',
				description: 'Մենք չենք վաճառում, փոխանակում կամ վարձակալությամբ տրամադրում ձեր անձնական տվյալները։ Սակայն, մենք կարող ենք ձեր տվյալները կիսել ծառայություններ մատուցողների (երրորդ կողմի վաճառողներ, որոնք օգնում են ծառայությունների մատուցմանը), իրավապահ մարմինների (երբ պահանջվում է ՀՀ օրենսդրությամբ կամ մեր իրավունքները պաշտպանելու համար), ինչպես նաև բիզնես փոխանցումների դեպքում (միաձուլում, ձեռքբերում կամ ակտիվների վաճառք):',
			},
			{
				title: 'Տվյալների անվտանգություն',
				description: 'Մենք կիրառում ենք ոլորտային ստանդարտներին համապատասխան անվտանգության միջոցներ՝ ձեր տեղեկատվությունը չթույլատրված մուտքից, փոփոխումից, հրապարակումից կամ ոչնչացումից պաշտպանելու համար՝ համապատասխան Հայաստանի տվյալների պաշտպանության կարգավորումներին:',
			},
			{
				title: 'Տվյալների պահպանում',
				description: 'Մենք պահպանում ենք ձեր տվյալները այնքան ժամանակ, որքան անհրաժեշտ է ծառայությունների մատուցման, օրենսդրական պահանջների կատարման և օրինական բիզնես շահերի ապահովման համար՝ համաձայն Հայաստանի Հանրապետության տվյալների պաշտպանության օրենքների:',
			},
			{
				title: 'Ձեր իրավունքներն ու ընտրանքները',
				description: 'ՀՀ օրենսդրության համաձայն՝ դուք կարող եք ունենալ իրավունքներ՝ մուտք գործելու, թարմացնելու կամ ջնջելու ձեր անձնական տվյալները, սահմանափակելու կամ առարկել տվյալների մշակմանը, ինչպես նաև անհրաժեշտության դեպքում հետ կանչելու ձեր համաձայնությունը։ Այս իրավունքները կիրառելու համար խնդրում ենք կապ հաստատել մեզ հետ "info@netspace.am" հասցեով:',
			},
			{
				title: 'Երրորդ կողմի հղումներ',
				description: 'Մեր կայքը կամ ծառայությունները կարող են պարունակել հղումներ դեպի երրորդ կողմերի կայքեր։ Մենք պատասխանատու չենք նրանց գաղտնիության քաղաքականության համար, ուստի խորհուրդ ենք տալիս ուսումնասիրել նրանց պայմանները:',
			},
			{
				title: 'Փոփոխություններ այս գաղտնիության քաղաքականության մեջ',
				description: 'Մենք կարող ենք ժամանակ առ ժամանակ թարմացնել այս Գաղտնիության քաղաքականությունը։ Ցանկացած փոփոխություն կհրապարակվի այս էջում՝ թարմացված ուժի մեջ մտնելու ամսաթվով:',
			},
			{
				title: 'Կապ մեզ հետ',
				description: 'Եթե ունեք հարցեր այս Գաղտնիության քաղաքականության վերաբերյալ, խնդրում ենք կապ հաստատել մեզ հետ՝ "NET SPACE", "Երևան, Հայաստան" (Հայաստանի Հանրապետություն), info@netspace.am, (+374) 44 77 50 77:',
			},
		],
	},

	en: {
		titles: [{ title: 'Introduction' }, { title: 'Information We Collect' }, { title: 'How We Use Your Information' }, { title: 'Information Sharing and Disclosure' }, { title: 'Data Security' }, { title: 'Data Retention' }, { title: 'Your Rights and Choices' }, { title: 'Third-Party Links' }, { title: 'Changes to This Privacy Policy' }, { title: 'Contact Us' }],
		contents: [
			{
				title: 'Introduction',
				description: '"NET SPACE" ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and protect your information when you use our services related to the computer, computer networks, and server software maintenance within the Republic of Armenia.',
			},
			{
				title: 'Information We Collect',
				description: 'We may collect the following types of information: Personal Information (Name, email address, phone number, and other contact details), Technical Information (IP addresses, device information, and log data), Service-Related Information (Details about your computer, network, or server maintenance needs), Payment Information (When applicable, we collect billing details to process transactions).',
			},
			{
				title: 'How We Use Your Information',
				description: 'We use the collected information to provide, maintain, and improve our services, diagnose and troubleshoot technical issues, process payments and invoices, communicate with you regarding service requests or updates, and comply with legal and regulatory obligations in the Republic of Armenia.',
			},
			{
				title: 'Information Sharing and Disclosure',
				description: 'We do not sell, trade, or rent your personal information. However, we may share your information with service providers (third-party vendors assisting in service delivery), legal authorities (when required by Armenian law or to protect our rights), and in case of business transfers (merger, acquisition, or sale of assets).',
			},
			{
				title: 'Data Security',
				description: 'We implement industry-standard security measures to safeguard your information against unauthorized access, alteration, disclosure, or destruction, in compliance with Armenian data protection regulations.',
			},
			{
				title: 'Data Retention',
				description: 'We retain your information as long as necessary for service provision, legal compliance, and legitimate business interests, following the data protection laws of the Republic of Armenia.',
			},
			{
				title: 'Your Rights and Choices',
				description: 'Under Armenian law, you may have rights to access, update, or delete your personal information, restrict or object to data processing, and withdraw consent where applicable. Please contact us at "info@netspace.am" to exercise these rights.',
			},
			{
				title: 'Third-Party Links',
				description: 'Our website or services may contain links to third-party sites. We are not responsible for their privacy practices, so we encourage you to review their policies.',
			},
			{
				title: 'Changes to This Privacy Policy',
				description: 'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.',
			},
			{
				title: 'Contact Us',
				description: 'If you have any questions about this Privacy Policy, please contact us at: "NET SPACE", "Yerevan, Armenia" (Republic of Armenia), info@netspace.am, (+374) 44 77 50 77.',
			},
		],
	},
};

//! Why choose
export const dataWhyChooseUs = {
	en: {
		title: 'Why choose us?',
		description: 'Since 2010, NetSpace has been providing cybersecurity and server uptime services to large organizations. We offer high-quality IT services that meet international standards, with a team of experienced professionals available 24/7. Our goal is to ensure the stable operation of your systems and data protection.',
		items: [
			{
				title: 'Operational Efficiency',
			},
			{
				title: 'High Quality Services',
			},
			{
				title: 'Affordable Service Delivery',
			},
			{
				title: 'Timely and Quality Solutions for Computer Issues',
			},
			{
				title: 'Our team consists of only leading and experienced specialists in the field',
			},
		],
	},

	hy: {
		title: 'Ինչու՞ ընտրել մեզ',
		description: '2010 թվականից NetSpace-ը խոշոր կազմակերպությունների համար տրամադրում է կիբերանվտանգության և սերվերների անխափան շահագործման ծառայություններ։ Մենք առաջարկում ենք բարձրորակ ՏՏ ծառայություններ, որոնք համապատասխանում են միջազգային չափանիշներին, փորձառու մասնագետների թիմով, հասանելի 24/7: Մեր նպատակն է ապահովել ձեր համակարգերի կայուն աշխատանքը և տվյալների պաշտպանությունը:',
		items: [
			{
				title: 'Օպերատիվություն',
			},
			{
				title: 'Ծառայությունների բարձր որակ',
			},
			{
				title: 'Ծառայությունների մատուցման մատչելիություն',
			},
			{
				title: 'Համակարգչային խնդիրների ժամանակին և որակյալ լուծումներ։',
			},
			{
				title: 'Մեր թիմում ներգրավված են միայն ոլորտում առաջատար և փորձառու մասնագետները',
			},
		],
	},
};

//! About Us
export const dataAboutUs = {
	en: {
		title: 'About Us',
		description: '#NetSpace has been providing cybersecurity and server uptime for a number of large companies since 2010. Our main goal is to provide partners with high-quality IT services in accordance with all international standards and norms. The company employs only highly qualified specialists who provide a high level of security 24/7.',
		image: {
			src: '/images/about-us.webp',
			alt: 'About Us section banner',
		},
	},

	hy: {
		title: 'Մեր մասին',
		description: '#NetSpace ընկերությունը 2010 թվականից ի վեր ապահովում է մի շարք խոշոր ընկերությունների կիբեռանվտանգությունը և սերվերների անխափան շահագործումը: Մեր գլխավոր նպատակը՝ գործընկերներին մատուցել բարձր որակի IT ծառայություններ՝ միջազգային բոլոր ստանդարտներին և նորմերին համապատասխան։ Ընկերությունում աշխատում են միայն բարձր որակավորում ունեցող մասնագետներ, ովքեր 24/7 ռեժիմով ապահովում են բարձր մակարդակի անվտանգություն։ ',
		image: {
			src: '/images/about-us.webp',
			alt: 'Մեր մասին նկար',
		},
	},
};

//! Home Hero Section
export const dataHomeHeroSection = {
	en: {
		title1: 'Stay connected',
		title2: 'with',
		image: {
			src: '/images/home-hero.webp',
			alt: 'Home hero banner',
		},
	},

	hy: {
		title1: 'Մնացեք կապի մեջ',
		title2: 'հետ',
		image: {
			src: '/images/home-hero.webp',
			alt: 'Գլխավոր էջի բաններ',
		},
	},
};

//! FAQ Section
export const dataFAQ = {
	en: {
		title: 'Network Hygiene Rules',
		description1: 'As is well known, the types of cyber threats are rapidly increasing, and hackers are constantly seeking new attack methods to bypass security systems.',
		description2: 'As a primary security rule, acquiring new knowledge and staying updated with industry news should be a priority.',
		items: [
			{
				title: 'Protect Your Personal Information',
				description: 'Avoid sharing sensitive data (full name, address, phone number, financial details) publicly. Use privacy settings on social media to limit who can see your information.',
			},
			{
				title: 'Use Strong, Unique Passwords',
				description: 'Create passwords with a mix of letters, numbers, and symbols. Use a password manager to keep track of your credentials. Enable two-factor authentication (2FA) for extra security.',
			},
			{
				title: 'Be Cautious with Links & Attachments',
				description: 'Do not click on suspicious links in emails, messages, or websites. Verify the sender before opening attachments to avoid malware.',
			},
			{
				title: 'Keep Your Devices & Software Updated',
				description: 'Regularly update your operating system, apps, and antivirus software. Enable automatic updates when possible.',
			},
			{
				title: 'Think Before You Post',
				description: 'Once something is online, it’s hard to remove completely. Avoid posting anything that could harm your reputation or others.',
			},
			{
				title: 'Beware of Scams & Phishing Attacks',
				description: 'If something seems too good to be true, it probably is. Never share passwords or financial details through email or text.',
			},
			{
				title: 'Secure Your Wi-Fi & Devices',
				description: 'Use a strong password for your home Wi-Fi network. Avoid using public Wi-Fi for sensitive activities unless using a VPN.',
			},
			{
				title: 'Be Mindful of Downloads',
				description: 'Only download software and apps from trusted sources. Scan files for malware before opening them.',
			},
			{
				title: 'Manage Your Digital Footprint',
				description: 'Regularly review and delete old accounts you no longer use. Google yourself to see what information is publicly available.',
			},
		],
	},

	hy: {
		title: 'Ցանցային հիգիենայի կանոններ',
		description1: 'Ինչպես հայտնի է, կիբեռսպառնալիքների տեսակները արագորեն աճում են, և հաքերները մշտապես փնտրում են նոր հարձակումների մեթոդներ՝ անվտանգության համակարգերը շրջանցելու համար։',
		description2: 'Որպես առաջնային անվտանգության կանոն՝ նոր գիտելիքներ ձեռք բերելը և ոլորտի նորություններին հետևելը պետք է լինի առաջնահերթություն։',
		items: [
			{
				title: 'Պաշտպանեք ձեր անձնական տեղեկատվությունը',
				description: 'Խուսափեք զգայուն տվյալներ (լրիվ անուն, հասցե, հեռախոսահամար, ֆինանսական մանրամասներ) հրապարակայնորեն տարածելուց։ Օգտագործեք գաղտնիության կարգավորումները սոցիալական մեդիայում՝ սահմանափակելու համար, թե ով կարող է տեսնել ձեր տեղեկատվությունը։',
			},
			{
				title: 'Օգտագործեք ուժեղ, եզակի գաղտնաբառեր',
				description: 'Ստեղծեք գաղտնաբառեր՝ օգտագործելով տառերի, թվերի և խորհրդանիշների համակցություն։ Օգտագործեք գաղտնաբառերի կառավարիչ ձեր հավատարմագրերը պահպանելու համար։ Միացրեք երկփուլային նույնականացումը (2FA) լրացուցիչ անվտանգության համար։',
			},
			{
				title: 'Զգուշացեք հղումներից և կցորդներից',
				description: 'Մի սեղմեք կասկածելի հղումների վրա էլ. փոստերում, հաղորդագրություններում կամ կայքերում։ Ստուգեք ուղարկողին նախքան կցորդները բացելը, որպեսզի խուսափեք վնասակար ծրագրերից։',
			},
			{
				title: 'Թարմացրեք ձեր սարքերն ու ծրագրակազմը',
				description: 'Պարբերաբար թարմացրեք ձեր օպերացիոն համակարգը, հավելվածները և հակավիրուսային ծրագիրը։ Հնարավորության դեպքում միացրեք ավտոմատ թարմացումները։',
			},
			{
				title: 'Մտածեք նախքան հրապարակելը',
				description: 'Երբ որևէ բան առցանց տեղադրվում է, այն դժվար է ամբողջությամբ հեռացնել։ Խուսափեք այնպիսի բաներ հրապարակելուց, որոնք կարող են վնասել ձեր կամ ուրիշների հեղինակությունը։',
			},
			{
				title: 'Զգուշացեք խարդախություններից և ֆիշինգային հարձակումներից',
				description: 'Եթե ինչ-որ բան չափազանց լավ է թվում՝ իրական լինելու համար, ապա, հավանաբար, այդպես էլ կա։ Երբեք մի տարածեք գաղտնաբառեր կամ ֆինանսական տվյալներ էլ. փոստով կամ հաղորդագրությամբ։',
			},
			{
				title: 'Ապահովեք ձեր Wi-Fi ցանցն ու սարքերը',
				description: 'Օգտագործեք ուժեղ գաղտնաբառ ձեր տան Wi-Fi ցանցի համար։ Խուսափեք հանրային Wi-Fi-ից զգայուն գործողություններ կատարելու համար, եթե չեք օգտագործում VPN։',
			},
			{
				title: 'Զգույշ եղեք ներբեռնումների հետ',
				description: 'Ներբեռնեք միայն վստահելի աղբյուրներից։ Ստուգեք ֆայլերը վնասակար ծրագրերի համար՝ նախքան դրանք բացելը։',
			},
			{
				title: 'Կառավարեք ձեր թվային հետքը',
				description: 'Պարբերաբար վերանայեք և հեռացրեք այն հաշիվները, որոնք այլևս չեք օգտագործում։ Գուգլեք ինքներդ ձեզ՝ տեսնելու համար, թե ինչ տեղեկատվություն է հանրային հասանելի։',
			},
		],
	},
};

//! News Section
export const dataNews = {
	en: {
		title: 'News',
		news: [
			{
				title: 'Leno Marketing / Business Forum',
				description: "<p>Recently, <strong>Net Space</strong> participated in the <strong>Business Forum</strong> organized by <strong>Leno Marketing</strong>, where the company's vision and goals were clearly presented.</p> <p>The goal of our company is to make the sector sustainably developing and constantly ensure high cybersecurity indicators.</p> <p>We strongly value the security and data confidentiality of our partners, which is the key to long-term and great cooperation.</p> <p>Thank you for trusting us.</p>",
				date: '24/07/24',
				file: {
					type: 'video',
					src: '/videos/news.mp4',
				},
			},
		],
	},

	hy: {
		title: 'Նորություններ',
		news: [
			{
				title: 'Leno Marketing / Business Forum',
				description: '<p>Վերջերս <strong>Net Space</strong> ընկերությունն իր մասնակցությունն ունեցավ <strong>Leno Marketing</strong> ընկերության կողմից կազմակերված <strong>Business Forum</strong>-ին, որտեղ հստակ ներկայացվեց ընկերության տեսլականն ու նպատակները։</p> <p>Մեր ընկերության նպատակն է ոլորտը դարձնել կայուն զարգացող և մշտապես ապահովել կիբեռանվտանգության բարձր ցուցանիշներ։</p> <p>Մենք խստիվ կարևորում ենք մեր գործընկերների անվտանգությունը և տվյալների գաղտնիությունը, ինչն էլ երկարաժամկետ և մեծ համագործակցությունների գրավականն է։</p> <p>Շնորհակալ ենք մեզ վստահելու համար:</p>',
				date: '24/07/24',
				file: {
					type: 'video',
					src: '/videos/news.mp4',
				},
			},
		],
	},
};
